function onCartUpdate() {
    fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            if(cart.item_count > 0){                
                $("cart-drawer").removeClass("is-empty");
                document.querySelector('.cart-count-bubble span[aria-hidden="true"]').textContent = cart.item_count;
                document.querySelector('.cart-count-bubble span.visually-hidden').textContent = cart.item_count + " items";
            }
          });
    $.ajax({
      url: '/?section_id=cart-drawer',
      type: 'GET',
      dataType: 'html',
      success:function(carthtml) {
        $('.drawer__inner').html($(carthtml).find('.drawer__inner').html());
      }
    });
    $("a.header__icon--cart")[0]?.click();
  }
  $(".step_cta_btn .bundleAddToCart").click(function(){
    bundleQuantity();
  })
  $(".include_cta_btn .bundleAddToCart").click(function(){
    bundleQuantity();
  })
  $(".bundleHeroProductBtn .bundleAddToCart").click(function(){
    bundleQuantity();
  })
  function bundleQuantity(){
    var product1AttrName1 = $(".bundleAddToCart").attr("name1");
    var product1AttrName2 = $(".bundleAddToCart").attr("name2");
    var customItems = [
      {id:product1AttrName1, quantity:1},
      {id:product1AttrName2, quantity:1}
    ];
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: {items: customItems},
      success: function(){
          onCartUpdate();
      }
    })
}